import { render } from "./V1ReferenceCodeCard.vue?vue&type=template&id=f798886a&scoped=true&ts=true"
import script from "./V1ReferenceCodeCard.vue?vue&type=script&lang=ts"
export * from "./V1ReferenceCodeCard.vue?vue&type=script&lang=ts"

import "./V1ReferenceCodeCard.vue?vue&type=style&index=0&id=f798886a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f798886a"]])

export default __exports__